<template>
  <button
    v-for="(data, idx) in buttonIcons"
    :key="idx"
    :class="['flex justify-center rounded-full bg-white', buttonStyle[page]]"
    @click="storeOpen(data.downloadLink)"
  >
    <div class="flex min-w-max items-center justify-start gap-2">
      <img :src="data.icon" class="size-[14px] lg:size-[22px]" loading="lazy" :alt="data.alt" />
      <span class="gn-text-xl min-w-fit text-center font-bold">
        {{ $t(data.text) }}
      </span>
    </div>
  </button>
</template>

<script setup>
import appleIcon from '~/assets/svg/btn_apple_icon.svg'
import googleIcon from '~/assets/svg/btn_google_icon.svg'

defineProps({
  page: {
    type: String,
    default: 'none'
  }
})

const buttonStyle = {
  none: 'w-full border border-slate-500 px-7 py-4',
  home: 'w-fit px-6 py-3 lg:h-[62px] lg:px-8'
}

const buttonIcons = [
  {
    icon: googleIcon,
    alt: 'playstore',
    text: 'download.android',
    downloadLink: 'https://play.google.com/store/apps/details?id=com.cognometricinnolab.guardiann'
  },
  {
    icon: appleIcon,
    alt: 'applestore',
    text: 'download.iphone',
    downloadLink:
      'https://apps.apple.com/ko/app/%EA%B0%80%EB%94%94%EC%95%A4-%EC%9E%90%EB%85%80-%ED%95%99%EC%8A%B5%EB%8A%A5%EB%A0%A5-%EB%B0%8F-%EC%A7%91%EC%A4%91%EB%A0%A5-%ED%96%A5%EC%83%81/id6479844209'
  }
]

const storeOpen = url => {
  window.open(url, '_blank')
}
</script>

<style lang="scss" scoped></style>
